import React, { useEffect, useState } from "react";
import { Button, ButtonToolbar, Loader, Container, Modal } from "rsuite";
import "./MusicSchedules.css";
import { useTranslation } from "react-i18next";
import MusicScheduleStores from "./MusicScheduleStores";

const MusicScheduleStoresModal = ({
  musicScheduleId,
  companyId,
  groupId,
  musicScheduleData,
  openModal,
  setOpenModal,
  setSelectedStores,
  ...props
}: {
  musicScheduleId?: number;
  companyId?: number;
  groupId?: number;
  musicScheduleData?: any;
  openModal: boolean;
  setOpenModal: Function;
  setSelectedStores?: Function;
}) => {
  const { t } = useTranslation();

  const [loader, setLoader] = useState(false);

  return (
    <div className="modal-container">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      <Modal
        open={openModal}
        backdrop={false}
        onClose={(e: any) => {
          setOpenModal("");
        }}
        size="lg"
      >
        <Modal.Header>
          <h4 className="text-center">
            {musicScheduleData?.group_name} {t("STORES")}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <div className="">
            <MusicScheduleStores
              withHeader={false}
              musicScheduleId={musicScheduleId}
              groupId={groupId}
            />
            <ButtonToolbar className="btn-center">
              <Button
                onClick={(e: any) => setOpenModal("")}
                color="red"
                appearance="primary"
              >
                {t("CLOSE")}
              </Button>
            </ButtonToolbar>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default MusicScheduleStoresModal;
